export const STATUS_REDUCER_STATE_ID = 'status';
